// extracted by mini-css-extract-plugin
module.exports = {"description":"Description_description__WI5Ba","hidetitles":"Description_hidetitles__oWc1K","showtitles":"Description_showtitles__bcJZH","truncate":"Description_truncate__ZRyB5"};